import { useState } from 'react';
import { IconButton, InputAdornment, TextField, useTheme } from '@mui/material';
import { Lock, Visibility, VisibilityOff } from '@mui/icons-material';

import type { PasswordInputProps } from './types';

export function PasswordInput({
  enableVisibilityToggle = true,
  showPassword,
  onShowPasswordChange,
  error,
  InputProps,
  ...textFieldProps
}: PasswordInputProps) {
  const [internalVisible, setInternalVisible] = useState(false);
  const isVisible = showPassword ?? internalVisible;

  const toggleVisibility = () => {
    const next = !isVisible;
    if (showPassword === undefined) {
      setInternalVisible(next);
    }
    onShowPasswordChange?.(next);
  };

  return (
    <TextField
      {...textFieldProps}
      type={isVisible ? 'text' : 'password'}
      error={error}
      size="small"
      fullWidth
      InputProps={{
        ...InputProps,
        startAdornment: (
          <InputAdornment position="start">
            <Lock sx={{ }} />
          </InputAdornment>
        ),
        endAdornment: enableVisibilityToggle ? (
          <InputAdornment position="end">
            <IconButton
              type="button"
              aria-label={isVisible ? 'Hide password' : 'Show password'}
              onClick={toggleVisibility}
              edge="end"
              size="small"
            >
              {isVisible ? (
                <VisibilityOff sx={{ }} />
              ) : (
                <Visibility sx={{ }} />
              )}
            </IconButton>
          </InputAdornment>
        ) : (
          InputProps?.endAdornment
        ),
      }}
      sx={{
        ...textFieldProps.sx,
      }}
    />
  );
}
